var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('keep-alive',[_c('item',{attrs:{"columnData":_vm.columnData,"is-activated":_vm.isActivated,"routeName":_vm.routeName,"menuName":_vm.menuName,"titleName":_vm.titleName,"parent":_vm.parent,"tab":_vm.tab,"currentIndex":"9"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f3b275","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customer/flyOrder.vue
// module id = null
// module chunks = 